import useIntlContext from './use-intl.esm10.js';

function useLocale() {
  return useIntlContext().locale;
}

export { useLocale as default };
//# sourceMappingURL=use-intl.esm3.js.map
